'use client';

import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import { FC, useEffect, useState } from 'react';

import { IconSort } from 'src/general/Icons/IconSort';
import buttonStyles from 'src/general/components/Button/Button.module.scss';
import { urlToPath } from 'src/general/helpers/urlToPath';
import { SortValues, sortValuesList, sortValuesListKeys } from 'src/types/CarFilters.types';

import { Shade } from 'src/general/components/Shade/Shade';
import styles from './PlpSort.module.scss';

const DEFAULT_SORT = SortValues.Recommended;

interface Props {
  prependTestId?: string;
}

export const PlpSort: FC<Props> = ({ prependTestId = '' }) => {
  const router = useRouter();
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const newUrl = new URL(window.location.toString());
      setValue(newUrl.searchParams.get('sortBy') ?? DEFAULT_SORT);
    }
  }, []);

  return (
    <label className={classNames(styles.root, 'PlpSort')}>
      <span className={styles.label}>Sort by:&ensp;</span>
      <span className="sr-only">{value}</span>
      <span className={classNames(styles.selectWrapper, 'shade_container')}>
        <select
          data-testid={`${prependTestId}SortMenuTrigger`}
          className={classNames(
            buttonStyles.root,
            `button--small`,
            `button--secondary`,
            styles.select,
            'PlpSort-select',
          )}
          value={value}
          onChange={(event) => {
            if (typeof window !== 'undefined' && event.target.value !== value) {
              // Build the new URL with the sort param
              const newUrl = new URL(window.location.toString());
              if (event.target.value !== DEFAULT_SORT) {
                newUrl.searchParams.set('sortBy', event.target.value);
              } else {
                newUrl.searchParams.delete('sortBy');
              }
              newUrl.searchParams.delete('page'); // Reset pagination
              setValue(event.target.value);
              router.push(urlToPath(newUrl));
            }
          }}
        >
          {value === '' && <option value="" />}
          {sortValuesListKeys.map((item) => (
            <option key={item} data-testid={`${prependTestId}SortMenuItem-${item}`} value={item}>
              {sortValuesList[item]}
            </option>
          ))}
        </select>
        <Shade />
        <span className={styles.iconWrapper}>
          <IconSort className={styles.icon} />
        </span>
      </span>
    </label>
  );
};
